'use client'

import ContentBlocks from '@/components/ContentBlocks'
import PageHeader from '@/components/PageHeader'
import { FC } from 'react'

interface PolicyPageLayoutProps {
	data: any
}

const PolicyPageLayout: FC<PolicyPageLayoutProps> = ({ data }) => {
	return (
		<div className="site-wrapper policy-layout">
			<div className="mb-[8rem]">
				<PageHeader title={data?.title} align="center" />
			</div>
			<ContentBlocks contentBlocks={data?.contentBlocks} />
		</div>
	)
}

export default PolicyPageLayout

